import React, { useState } from "react";
import { IonToolbar, IonInput, IonIcon, IonButtons } from "@ionic/react";
import { closeOutline, search } from "ionicons/icons";
import { searchIcon } from "../../shared/assets/icons/icons";
import BackButton from "../../../../components/BackButton/BackButton";
import classNames from "classnames/bind";
import styles from "./ProductsSearchBarHeader.module.scss";
import { useConfig } from "../../../../providers/config";
import { ProductsSearchBarHeaderProps } from "@core/types";
import { useSearchParams } from "../../../../hooks/useSearchParams";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

const ProductsSearchBarHeader = ({
  onClean,
  showBackButton = true,
  showCancelButton,
  ...inputProps
}: ProductsSearchBarHeaderProps) => {
  const config = useConfig();
  const [searchText, setSearchText] = useState("");
  const { set: setSearchParam, delete: deleteSearchParam } = useSearchParams();
  const { t } = useTranslation();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSearchParam("q", searchText);
  };

  const handleChange = (value: string) => {
    setSearchText(value);
    if (value.length >= config.search.minSearchLength) {
      setSearchParam("q", value);
    }

    if (value.trim().length === 0) {
      deleteSearchParam("q");
    }
  };

  return (
    <IonToolbar className={cx("toolbar", "ion-hide-md-up")}>
      <form onSubmit={handleSubmit} className={cx("searchBox__form")}>
        <div className={cx("searchBox", { searchBox__backButton: showBackButton })}>
          <IonButtons slot="start" className={cx("searchBox__buttons", { "ion-hide": !showBackButton })}>
            <BackButton />
          </IonButtons>
          <IonInput
            clearInput
            type="search"
            value={searchText}
            inputMode="search"
            enterkeyhint="search"
            placeholder={t("Search in the store")}
            debounce={config.search.inputDebounceTimeMs}
            className={cx("searchBox__input", "ion-no-padding")}
            onIonChange={(e) => handleChange(e.detail.value || "")}
            {...inputProps}
          />
          {!!searchText.length && (
            <div onClick={onClean}>
              <div className={cx("cleanSearch", "cleanSearch--sm", "ion-hide-md-up")}>
                <IonIcon className={cx("cleanSearch__icon", "cleanSearch__icon--sm")} icon={closeOutline} />
              </div>
              <div className={cx("cleanSearch", "cleanSearch--md", "ion-hide-md-down")}>
                <IonIcon className={cx("cleanSearch__icon", "cleanSearch__icon--md")} icon={closeOutline} />
              </div>
            </div>
          )}
          <button type="submit" className={cx("submit-button")}>
            <div className={cx("searchIcon", "searchIcon--sm", "ion-hide-md-up")}>
              <IonIcon className={cx("searchIcon__icon", "searchIcon__icon--sm")} icon={searchIcon} />
            </div>
            <div className={cx("searchIcon", "searchIcon--md", "ion-hide-md-down")}>
              <IonIcon className={cx("searchIcon__icon", "searchIcon__icon--md")} icon={search} />
            </div>
          </button>
        </div>
      </form>
    </IonToolbar>
  );
};

ProductsSearchBarHeader.displayName = "CORE_ProductsSearchBarHeader";

export default ProductsSearchBarHeader;
